import { useQuery } from '@tanstack/react-query';
import { getClaudeUsage } from '../api/usage';

function fmtRemaining(resetAt: string): string {
  const ms = new Date(resetAt).getTime() - Date.now();
  if (ms <= 0) return 'まもなくリセット';
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return h > 0 ? `残り約 ${h}h` : `残り約 ${m}m`;
}

export function ClaudeUsageWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['claude-usage'],
    queryFn: getClaudeUsage,
    refetchInterval: 45000,
    retry: 1,
  });

  const containerStyle: React.CSSProperties = {
    flexShrink: 0,
    padding: '10px 12px',
    borderTop: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(0,0,0,0.15)',
  };

  if (isLoading) {
    return (
      <div style={containerStyle}>
        <div style={{ fontSize: 11, color: 'rgba(205,188,205,0.6)', textAlign: 'center' }}>
          使用量を取得中…
        </div>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div style={containerStyle}>
        <div style={{ fontSize: 11, color: 'rgba(205,188,205,0.5)', textAlign: 'center' }}>
          使用量データなし
        </div>
      </div>
    );
  }

  const pct = data.limitTokens > 0
    ? Math.min(100, Math.round((data.usedTokens / data.limitTokens) * 100))
    : 0;

  const barColor = pct >= 90 ? '#ef4444' : pct >= 70 ? '#f59e0b' : '#22c55e';

  return (
    <div style={containerStyle}>
      <div style={{ fontSize: 11, color: 'rgba(205,188,205,0.75)', marginBottom: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Claude 使用量</span>
        <span style={{ fontVariantNumeric: 'tabular-nums' }}>{pct}%</span>
      </div>
      <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 4, height: 6, overflow: 'hidden', marginBottom: 5 }}>
        <div style={{ width: `${pct}%`, height: '100%', background: barColor, borderRadius: 4, transition: 'width 0.4s ease' }} />
      </div>
      <div style={{ fontSize: 10, color: 'rgba(205,188,205,0.55)', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ fontVariantNumeric: 'tabular-nums' }}>
          {(data.usedTokens / 1000).toFixed(0)}k / {(data.limitTokens / 1000).toFixed(0)}k
        </span>
        <span>{fmtRemaining(data.resetAt)}</span>
      </div>
    </div>
  );
}
